export const PARTNER_SUBSCRIPTION_ADVANTAGE_KEYS = [1, 2, 3, 4, 5, 6].map(
    (index) => `CHECKOUT.PLAN.ADVANTAGE_${index}`,
);
